import { render, staticRenderFns } from "./onboarding-card.vue?vue&type=template&id=674a526e&scoped=true&"
import script from "./onboarding-card.vue?vue&type=script&lang=js&"
export * from "./onboarding-card.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-card.vue?vue&type=style&index=0&id=674a526e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a526e",
  null
  
)

export default component.exports